export default function(str, reps) {
  var s = '';
  while (--reps >= 0) s += str;
  return s;
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/repeat.js
// module id = 875
// module chunks = 0